<template>
  <img class="image-preview" :src="url" />
</template>
<script>
export default {
  name: 'ImageViewer',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>
